const isProd = process.env.NODE_ENV === 'production'

let serveUrl = ''

// 联调环境地址
if (!isProd) {
  serveUrl = ''
}
const prefix = `${serveUrl}`

module.exports = {
  getList: {
    url: `${prefix}/get/list`,
    method: 'GET',
  },
}
